import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueAnalyticsController', IssueAnalyticsController);

    function IssueAnalyticsController(
        $scope,
        CompanyFactory,
        CompaniesFactory,
        FormVerificationService
    ) {
        var vm = this,
            workersParamList = {
                page_size: 100,
                is_active: true,
            },
            haParamList = {
                page_size: 1000,
            };

        vm.options = {
            scales: {
                yAxes: [
                    {
                        scaleLabel: {
                            display: true,
                            labelString: 'Ilość zgłoszeń',
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                if (value % 1 === 0) {
                                    return value;
                                }
                            },
                        },
                    },
                ],
                xAxes: [
                    {
                        scaleLabel: {
                            display: true,
                            labelString: 'Data',
                        },
                    },
                ],
            },
        };

        vm.periods = [
            { id: 'year', name: 'Lata' },
            { id: 'month', name: 'Miesiące' },
            { id: 'day', name: 'Dni' },
        ];

        vm.statuses = [
            { id: 'fixed', name: 'Zrealizowano' },
            { id: 'rejected', name: 'Odrzucono' },
        ];

        // workers & housing associations
        CompanyFactory.readCompany().then(function (response) {
            CompaniesFactory.readEmployees(
                response.data.organization.party_uuid,
                workersParamList
            ).then(function (employeesResponse) {
                vm.workersFromBackend = employeesResponse.data.results;
            });

            CompaniesFactory.readHousingAssociations(
                response.data.organization.party_uuid,
                haParamList
            ).then(function (haResponse) {
                vm.haFromBackend = haResponse.data.results;
            });
        });

        $scope.period_type = vm.periods[0].id; // for default 'year'

        $scope.$watch(
            '[dateFrom, dateTo, period_type, assigned_to, status, ha_assign, issue_category]',
            function () {
                CompanyFactory.readCompany().then(function (comp_id) {
                    FormVerificationService.clearErrors(vm.periodForm);
                    CompaniesFactory.readIssueReport(comp_id.data.organization.party_uuid, {
                        date_from: $scope.dateFrom,
                        date_to: $scope.dateTo,
                        assigned_to: $scope.assigned_to,
                        period: $scope.period_type,
                        status: $scope.status,
                        customer: $scope.ha_assign,
                        issue_category: $scope.issue_category,
                    }).then(function (response) {
                        vm.analyticsFromBackend = response.data.periods;
                        vm.dateFrom = vm.analyticsFromBackend[0].start;
                        vm.dateTo =
                            vm.analyticsFromBackend[
                                vm.analyticsFromBackend.length - 1
                            ].end;

                        vm.data = [];
                        vm.tmp_data = [];
                        vm.labels = [];
                        vm.series = [];

                        for (var i = 0; i < response.data.periods.length; i++) {
                            vm.tmp_data.push(
                                response.data.periods[i].stats.count
                            );
                            vm.labels.push(
                                response.data.periods[i].start +
                                    ' - ' +
                                    response.data.periods[i].end
                            );
                        }

                        vm.data.push(vm.tmp_data);
                    }, function (response) {
                        FormVerificationService.error(response.data, vm.periodForm);
                    });
                });
            }
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/issues-analytics/issues-analytics.controller.ts